import * as React from "react"
import { cn } from "../../../lib/utils"

interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ElementType
  title: string
  description?: string
  action?: React.ReactNode
  iconClassName?: string
  containerClassName?: string
}


export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  iconClassName,
  containerClassName,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex min-h-[400px] flex-col items-center justify-center rounded-md p-8 text-center animate-in fade-in duration-500",
        className
      )}
      {...props}
    >
      <div className={cn("flex flex-col items-center justify-center", containerClassName)}>
        {Icon && (
          <div className={cn(
            "mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-muted/30",
            iconClassName
          )}>
            <Icon className="h-10 w-10 text-muted-foreground/60" strokeWidth={1.5} />
          </div>
        )}
        <h3 className="text-xl font-bold tracking-tight text-foreground">{title}</h3>
        {description && (
          <p className="mt-2 max-w-[320px] text-sm text-muted-foreground leading-relaxed">
            {description}
          </p>
        )}
        {action && <div className="mt-8">{action}</div>}
      </div>
    </div>
  )
}
